export type CourseStatusType = 'Pristine' | 'InProgress' | 'Completed';

export const COURSE_STATUS: { [key: string]: CourseStatusType } = {
  PRISTINE: 'Pristine',
  IN_PROGRESS: 'InProgress',
  COMPLETED: 'Completed',
};
